import {
  PARTIAL_PAYMENT_GUEST_LABEL,
  PARTIAL_PAYMENT_GUEST_REQUIRED_LABEL,
} from '../constants/bookingConst';
import '../css/GuestPartialPaymentOption.css';

/**
 * The guest's "Partial payment" checkbox, shown inline beside the Total label
 * (see BookingTotalRow). Unticked it reads "Partial payment"; ticked it spells
 * out the club's rule ("Required partial payment is 20%"). The amounts
 * themselves are drawn by BookingTotalRow.
 *
 * Only rendered when Config -> Pricing -> "Partial Payment Allowed (%)" is
 * above zero (see isPartialPaymentEnabled) — the parent decides that.
 *
 * @param {object} props
 * @param {boolean} props.checked - whether the guest has ticked the box
 * @param {(checked: boolean) => void} props.onChange - called with the new ticked state
 * @param {number} props.percent - the configured minimum percentage (1-100)
 * @param {string} props.id - unique id for the checkbox, so the label stays
 *   tied to it when two forms are on the page
 * @param {boolean} [props.disabled] - read-only (booking submitted, or the
 *   admin viewing it). Not the native `disabled` attribute: that greys the
 *   tick out, and a read-only choice should still read as the choice made.
 * @returns {JSX.Element}
 */
function GuestPartialPaymentOption({ checked, onChange, percent, id, disabled = false }) {
  const label = checked
    ? PARTIAL_PAYMENT_GUEST_REQUIRED_LABEL.replace('{percent}', percent)
    : PARTIAL_PAYMENT_GUEST_LABEL;

  return (
    <label className={`gpp-label${checked ? ' gpp-label-on' : ''}${disabled ? ' gpp-label-locked' : ''}`} htmlFor={id}>
      <input
        id={id}
        type="checkbox"
        className="gpp-checkbox"
        checked={checked}
        aria-disabled={disabled}
        tabIndex={disabled ? -1 : undefined}
        onChange={(e) => { if (!disabled) onChange(e.target.checked); }}
      />
      <span>{label}</span>
    </label>
  );
}

export default GuestPartialPaymentOption;
